import ComparisonTableVersus from './components';

export default ComparisonTableVersus;
